import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-vat-verification',
  templateUrl: './vat-verification.component.html',
  styleUrls: ['./vat-verification.component.scss']
})
export class VatVerificationComponent {

  constructor(
    private dialogRef: MatDialogRef<VatVerificationComponent>,
  ) {}

  onUpdateDetails(): void {
    this.dialogRef.close('account-info');
  }

  onOptOut(): void {
    this.dialogRef.close('opt-out');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}